import React from 'react';
import Modal from '../../../ui/Modal';

const KZT = new Intl.NumberFormat('ru-KZ', { maximumFractionDigits: 2 });

const formatDate = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    timeZone: 'Europe/Moscow',
  });
};

const paymentLabel = (status) => {
  if (status === 1) return 'Оплачен';
  if (status === 2) return 'Ожидает оплаты';
  return '—';
};

function StatusBadge({ name }) {
  const n = String(name || '').toLowerCase();
  let tone = 'neutral';
  if (/ожидает|новая/.test(n))           tone = 'warning';
  else if (/подтверждена|готов|оплачен|доставлен|закрыт|завершен/.test(n)) tone = 'success';
  else if (/отмен|возврат|отклон/.test(n))     tone = 'danger';
  else if (/в пути|производ|собира/.test(n))   tone = 'info';
  return <span className={`crmpage__status crmpage__status--${tone}`}>{name || '—'}</span>;
}

const OrderDetailsModal = ({ isOpen, onClose, order, orderDetails }) => {
  const data = order || orderDetails;
  if (!data) return null;

  const items = (data.items || []).filter(i => Number(i['Количество'] || i.quantity) > 0);
  const totalAmount = items.reduce(
    (sum, item) => sum + Number(item['Количество'] || item.quantity || 0) * Number(item['Цена'] || item.price || 0),
    0
  );

  return (
    <Modal
      isOpen={!!isOpen}
      onClose={onClose}
      title={`Заявка №${data.order_number ?? '—'}`}
      subtitle={data.client_name}
      size="lg"
    >
      <div className="uimodal-field">
        <span className="uimodal-field__label">Договор</span>
        <span className="uimodal-field__value">{data.contract_info || '—'}</span>
      </div>
      <div className="uimodal-field">
        <span className="uimodal-field__label">Адрес доставки</span>
        <span className="uimodal-field__value">{data.delivery_address || '—'}</span>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Дата заказа</span>
          <span className="uimodal-field__value">{formatDate(data.order_date)}</span>
        </div>
        <div>
          <span className="uimodal-field__label">Дата доставки</span>
          <span className="uimodal-field__value">{formatDate(data.delivery_date)}</span>
        </div>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Статус заказа</span>
          <span className="uimodal-field__value"><StatusBadge name={data.status_name} /></span>
        </div>
        <div>
          <span className="uimodal-field__label">Статус оплаты</span>
          <span className="uimodal-field__value"><StatusBadge name={paymentLabel(data.id_payment_status)} /></span>
        </div>
      </div>

      <table className="uimodal-table">
        <thead>
          <tr>
            <th>Товар</th>
            <th className="num">Кол-во</th>
            <th className="num">Цена</th>
            <th className="num">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? items.map((item, index) => {
            const qty = Number(item['Количество'] || item.quantity || 0);
            const price = Number(item['Цена'] || item.price || 0);
            return (
              <tr key={index}>
                <td>{item['Товар'] || item.product_name || '—'}</td>
                <td className="num">{qty}</td>
                <td className="num">{KZT.format(price)} ₸</td>
                <td className="num">{KZT.format(qty * price)} ₸</td>
              </tr>
            );
          }) : (
            <tr><td colSpan={4} style={{ textAlign: 'center', padding: 20, color: '#8C8077' }}>Позиций нет</td></tr>
          )}
        </tbody>
      </table>

      <div className="uimodal-total">
        <span className="uimodal-total__label">Общая сумма</span>
        <span className="uimodal-total__value">{KZT.format(totalAmount)} ₸</span>
      </div>
    </Modal>
  );
};

export default OrderDetailsModal;
